<template>
  <div class="item" id="cardInfo.id" v-on:click="directToPage">
    <div class="img-box">
      <el-image :src="cardInfo.src" class="card-img" fit="contain" style="width: 260px"></el-image>
    </div>
    <div class="info-ch">
      <h6 class="ellipsis">{{cardInfo.infoCh}}</h6>
    </div>
  <div class="info-en">
    <h6 class="ellipsis">{{cardInfo.infoEn}}</h6>
  </div>
  </div>
</template>
<script>
  export default {
    props: [
      'cardInfo'
    ],
    methods: {
      directToPage () {
        if (this.cardInfo.url === 'understand') {
          window.open('https://www.amtb.tw/blog/about-master-chin-kung', '_self')
        } else {
          this.$router.push(this.cardInfo.url)
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  @import "../assets/style/mixin";

  .item {
    cursor: pointer;
    background-color: #E7F5F9;
    padding: 20px 20px 20px 20px;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    position: relative;
    text-align: center;
    margin:25px 0 0 25px;
    .img-box {
      transition: 1s;
      -moz-transition: 1s; /* Firefox 4 */
      -webkit-transition:1s; /* Safari and Chrome */
      -o-transition: 1s; /* Opera */
      margin-bottom: 1rem;
      @extend %block-center;
    }
    .info-ch {
      width: 100%;
      padding: 0 10px;
      h6 {
        overflow: hidden;
        font-size: 1.5rem;
        font-weight: 500;
        line-height: 1.2;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #808285;
        letter-spacing: 4px;
      }
    }
    .info-en {
      width: 100%;
      padding: 10px 20px;
      h6 {
        overflow: hidden;
        font-size: 1.0rem;
        font-family: "PingFang SC", "Helvetica Neue", "Hiragino Sans GB", "Segoe UI", "Microsoft YaHei", "微软雅黑", sans-serif;
        letter-spacing: 0.5px;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #808285;
      }
    }
  }
  .img-box:hover{
    transform:scale(1.1, 1.1);
    -ms-transform:scale(1.1, 1.1); 	/* IE 9 */
    -moz-transform:scale(1.1, 1.1); 	/* Firefox */
    -webkit-transform:scale(1.1, 1.1); /* Safari 和 Chrome */
    -o-transform:scale(1.1, 1.1);
  }
</style>



// WEBPACK FOOTER //
// playcard3.vue?24450d74